import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlMaker } from 'src/app/commons/url-maker';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { TbAuthService } from '@tb/auth';
import { ProductRelease } from 'src/app/model/ProductRelease';
import { NewOperationResult } from './operation-result-new';
import { LoginService } from './login.service';
import { ImprovementRequestSearch } from 'src/app/model/ImprovementRequestSearch';
import { ImprovementRequest } from 'src/app/model/ImprovementRequest';

@Injectable({
    providedIn: 'root',
})
export class ImprovementrequestService {
    storeApiUrl: string;
    proxyApiUrl: string;

    constructor(private http: HttpClient, private tbAuthService: TbAuthService, private loginService: LoginService,) {
        this.storeApiUrl = environment.settings.storeApiUrl;
        this.proxyApiUrl = environment.settings.microareaserviceproxy;
    }

    public async getImpReqSearchData() : Promise<NewOperationResult<ImprovementRequestSearch[]>>  {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('getImpReqSearchData')
            .appendSegment(this.tbAuthService.getAccountName())
            .toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const reqBody = {
            "authToken": environment.auth.authToken,
        }

        const bodyString = JSON.stringify(reqBody);
        return this.http
        .post<NewOperationResult<ImprovementRequestSearch[]>>(url.toString(), bodyString, { headers })
        .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getImpReqSearchData')))
        .toPromise();
    }

    public async getImprovementRequests(product: string, functionalArea: string = '', init: string = '', end: string = '', status: string = '') : Promise<NewOperationResult<ImprovementRequest[]>>  {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('getImprovementRequests')
            .appendSegment(this.tbAuthService.getAccountName())
            .appendParameter('productCode', product)
            if(functionalArea) url.appendParameter('functionalArea', functionalArea)
            if(init) url.appendParameter('init', init)
            if(end) url.appendParameter('end', end)
            if(status) url.appendParameter('status', status)
            url.toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const reqBody = {
            "authToken": environment.auth.authToken,
        }

        const bodyString = JSON.stringify(reqBody);
        return this.http
        .post<NewOperationResult<ImprovementRequest[]>>(url.toString(), bodyString, { headers })
        .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getImprovementRequests')))
        .toPromise();
    }
}
